module.exports = __webpack_public_path__ + "img/license.6816f05e.jpg";